import styled from "styled-components";

export const Charts = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: 6px;
`;

export const ChartTit = styled.div`
  color: ${(props) => props.theme.colors.gray};
  font-size: 1.2rem;
  font-weight: 400;
`;
